module.exports = " <div class=\"carousel__grid brands v5\"> <div class=container> <div id=des-items-slider-prev class=\"carousel-btn carousel-btn-prev\"> <i class=\"fa fa-angle-left fa-4x\"></i> </div> <div class=\"brands-slider owl-carousel\"> <div class=brands__item ng-repeat=\"item in $ctrl.shCtrl.globalBanners.homeFooterMarcas.items\"> <img ng-src={{item.imageUrl}} alt=Brand1 class=\"img-responsive center-block\"/> </div> </div> <div id=brands-slider-next class=\"carousel-btn carousel-btn-next\"> <i class=\"fa fa-angle-right fa-4x\"></i> </div> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/home/brands/templates/brands-t5.view.html
 ** module id = 793
 ** module chunks = 7
 **/